import React, { useEffect } from 'react';
import moment from 'moment';
import Form, { FormInstance } from 'antd/lib/form';

import { Col, DatePicker, Row, Select } from 'antd';
import { ClientFeatureConfig } from '../../../types/Feature';
import FormListAddButton from '../../FormListAddButton';
import { QuoteDenyingConfigAttributes } from '../../../../../server/src/models';
import FormListRemoveButton from '../../FormListRemoveButton';

const cardHeaderTitleStyle = { fontSize: '18px' };
const { Option } = Select;

interface ClosingScheduleFormSectionProps {
    isDetailMode: boolean;
    formInstance: FormInstance;
    closingScheduleConfig?: ClientFeatureConfig<QuoteDenyingConfigAttributes>;
}

interface FormItemSelectProps {
    fieldKey: number;
    isDetailMode: boolean;
    value?: string;
}

interface FormItemDateProps {
    isDetailMode: boolean;
    name: (string | number)[];
    label: string;
    value?: Date;
}

const FormItemDate = ({ isDetailMode, name, label, value }: FormItemDateProps) => {
    const formattedValue = moment(value).format('MMM Do YYYY, HH:mm');
    return (
        <Form.Item name={name} label={label} labelCol={{ span: 8 }}>
            {isDetailMode ? (
                formattedValue
            ) : (
                <DatePicker showTime format="MMMM Do YYYY, HH:mm" style={{ width: '100%' }} />
            )}
        </Form.Item>
    );
};

const FormItemSelect = ({ fieldKey, isDetailMode, value }: FormItemSelectProps) => {
    const repeatOptions = [
        { label: 'Yearly', value: 'YEARLY' },
        { label: 'Monthly', value: 'MONTHLY' },
        { label: 'Weekly', value: 'WEEKLY' },
        { label: 'Daily', value: 'DAILY' },
        { label: 'No repeat', value: '' },
    ];

    return (
        <Form.Item labelCol={{ span: 8 }} name={[fieldKey, 'repeat']} label="Repeat ?">
            {isDetailMode ? (
                <span>{value}</span>
            ) : (
                <Select>
                    {repeatOptions.map(({ label: optLab, value: val }) => (
                        <Option key={val} value={val}>
                            {optLab}
                        </Option>
                    ))}
                </Select>
            )}
        </Form.Item>
    );
};

const ClosingScheduleFormSection: React.FC<ClosingScheduleFormSectionProps> = (
    props: ClosingScheduleFormSectionProps,
) => {
    const { closingScheduleConfig: csConfig, formInstance, isDetailMode } = props;

    useEffect(() => {
        if (csConfig) {
            formInstance.setFields([
                {
                    name: 'closingSchedule',
                    value: csConfig.config.closingSchedules.map((c) => ({
                        start: moment(c.start),
                        end: moment(c.end),
                        repeat: c.repeat,
                    })),
                },
            ]);
        }
    }, [csConfig]);

    return (
        <div className="card border-0" id="closing-schedule-section">
            <div className="card-header border-bottom d-flex justify-content-between align-items-center bg-white">
                <p className="m-0 p-0 h5" style={cardHeaderTitleStyle}>
                    Closing Schedule
                </p>
            </div>
            <div className="card-body">
                <Row gutter={24}>
                    <Col span={24}>
                        <Form.List name="closingSchedule">
                            {(services, { add: addCS, remove: removeCS }): JSX.Element => (
                                <>
                                    {services.map(({ fieldKey, name }) => (
                                        <Row key={fieldKey} gutter={24}>
                                            <Col span={2} />
                                            <Col span={5}>
                                                <FormItemDate
                                                    name={[fieldKey, 'start']}
                                                    label="Start"
                                                    value={csConfig?.config.closingSchedules[fieldKey]?.start}
                                                    isDetailMode={isDetailMode}
                                                />
                                            </Col>
                                            <Col span={5}>
                                                <FormItemDate
                                                    name={[fieldKey, 'end']}
                                                    label="End"
                                                    value={csConfig?.config.closingSchedules[fieldKey]?.end}
                                                    isDetailMode={isDetailMode}
                                                />
                                            </Col>
                                            {/* <Col span={6}>
                                                <FormItemSelect
                                                    value={csConfig?.config.closingSchedules[fieldKey]?.repeat}
                                                    fieldKey={fieldKey}
                                                    isDetailMode={isDetailMode}
                                                />
                                            </Col> */}
                                            <Col span={4}>
                                                <FormListRemoveButton
                                                    id={`closing_schedule_delete_${name}`}
                                                    remove={removeCS}
                                                    name={name}
                                                    isDetailMode={isDetailMode}
                                                />
                                            </Col>
                                            <Col span={2} />
                                        </Row>
                                    ))}
                                    <FormListAddButton
                                        id="add-closing-schedule"
                                        add={addCS}
                                        isDetailMode={isDetailMode}
                                        text="Add a closing Schedule"
                                    />
                                </>
                            )}
                        </Form.List>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default ClosingScheduleFormSection;
